export const tableConfig = {
    configuration: true,
    table: {
        leftWidth: 100,
        height: 250,
        selection: true,
        columns: [
            {
                label: '专业公司',
                prop: 'professionalCompany',
                sort: true,
                width: 150
            },
            {
                label: '分公司',
                prop: 'companyName',
                sort: true,
                width: 150
            },
            {
                label: '服务平台',
                prop: 'siteName',
                sort: true,
                width: 150
            },
            {
                label: '发车单号',
                prop: 'dispatchNo',
                sort: true,
                width: 150
            },
            {
                label: '发车单创建时间',
                prop: 'dispatchCreateTime',
                sort: true,
                width: 150
            },
            {
                label: '发车单完成时间',
                prop: 'completionTime',
                sort: true,
                width: 150
            },
            {
                label: '供应商编码',
                prop: 'carrierCode',
                sort: true,
                width: 150
            },
            {
                label: '供应商名称',
                prop: 'carrierName',
                sort: true,
                width: 150
            },
            {
                label: '司机编码',
                prop: 'driverNo',
                width: 150,
                sort: true
            },
            {
                label: '司机名称',
                prop: 'driver',
                width: 150,
                sort: true
            },
            {
                label: '司机联系方式',
                prop: 'driverContactWay',
                width: 150,
                sort: true
            }
        ],
        action: {
            list: []
        }
    },
    leftOperation: false,
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    }
};

export const importConfig = {
    action: '',
    multiple: false,
    ImportTitle: '导入',
    accept: '.xlsx', // 筛选文件
    showFileList: false,
    fileType: '只能上传Excel文件',
    manualUpload: true
};

export const verifyConfig = {
    switch: true, // 是否开启校验
    fileSize: '',
    whiteList: ['xlsx', 'xls'] // 校验文件格式
};
